import Vue from 'vue'
import store from '../../store'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      shares: [],
      reference: null,
      initial: {
        key: null,
        type: null,
        name: null,
        comment: null,
        category: null,
        scope: null,
        enable: true,
        contents: {},
        schools: {},
        owner: null,
        createdAt: null,
        updatedAt: null
      }
    }
  },
  getters: {
    shares (state) {
      return state.shares
    },
    reference (state) {
      return state.reference
    },
    initial (state) {
      return state.initial
    }
  },
  mutations: {
    init (state, payload) {
      state.shares = payload
    },
    add (state, payload) {
      state.shares.push(payload)
    },
    update (state, payload) {
      const index = state.shares.findIndex(share => share.key === payload.key)
      if (index !== -1) {
        Vue.set(state.shares, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.shares.findIndex(share => share.key === payload.key)
      if (index !== -1) {
        state.shares.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }, payload) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('shares')
        var reference = null
        if (payload) {
          reference = dbRef.where('schools.' + payload, '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        } else {
          reference = dbRef.onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        }
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['shares/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var ref = null
        if (payload.key === null) {
          ref = db.collection('shares').doc()
          payload.key = ref.id
        } else {
          ref = db.collection('shares').doc(payload.key)
        }
        ref.set(payload)
          .then(function () {
            console.log('Document successfully written!')
            resolve()
          })
          .catch(function (error) {
            console.error('Error writing document: ', error)
            resolve()
          })
      })
    },
    delete ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        db.collection('shares').doc(payload).delete().then(function () {
          console.log('Document successfully deleted!')
          resolve()
        }).catch(function (error) {
          console.error('Error removing document: ', error)
          resolve()
        })
      })
    }
  }
}
